const messages = {
  backToArchive: 'press.release.page.back',
};

export default messages;
